import type { NavigationPlugin } from '../types';

export const broadstreetRefreshPlugin: NavigationPlugin = {
  name: 'broadstreet-refresh',
  handler() {
    setTimeout(() => {
      const banner = document.querySelector('.srp__bs-banner banner-zone');
      if (banner == null) return;

      const firstChild = banner.childNodes[0];
      if (firstChild && firstChild.childNodes.length > 0) {
        return;
      }

      window.broadstreet?.clearCampaignLog();
      window.broadstreet?.loadZone(banner);
    }, 500);
  },
};
